import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { formatTimeDisplay, calculateDurationMinutes } from 'lib/timeHelpers';
import { findStatus } from 'lib/findStatus';
import { AgeDefault } from 'lib/DefaultData';
import { parseISO, isBefore, isToday } from 'date-fns';

const CardClassSchedule = ({ item }) => {
  const navigate = useNavigate();

  const goToBook = (paramsItem) => {
    navigate(`/learn/class/${paramsItem.class.id}?schedule_id=${paramsItem.id}`);
  };

  const startTimeFormatted = formatTimeDisplay(item.start_time);

  const durationMinutes = calculateDurationMinutes(
    item.start_time,
    item.end_time,
    item.class?.duration,
  );

  const isPassed = useMemo(() => {
    try {
      if (!item.start_date || !item.start_time) return false;

      const now = new Date();
      const classDateTime = parseISO(item.start_date);
      const [hours, minutes] = item.start_time.split(':');

      classDateTime.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);

      return isBefore(classDateTime, now);
    } catch (error) {
      return false;
    }
  }, [item.start_date, item.start_time]);

  return (
    <div className="flex flex-row items-center gap-2">
      <div className="w-[120px] hidden md:flex flex-col">
        <span className="text-base font-semibold">{startTimeFormatted}</span>
        <span className="text-sm font-light">{durationMinutes}</span>
      </div>

      <div className="bg-white flex flex-col md:flex-row md:items-center justify-between font-semibold rounded-xl py-6 px-6 flex-1">
        <div className="flex flex-row gap-1 justify-start items-center mb-3 md:mb-0 md:hidden">
          <span className="text-base font-semibold">{startTimeFormatted}</span>
          <span className="text-base font-semibold">|</span>
          <span className="text-base font-light">{durationMinutes}</span>
        </div>

        {/* Info kelas */}
        <div className="flex flex-col mb-3 md:mb-0 md:flex-row justify-between md:items-center flex-1 gap-3">
          <div className="flex flex-col gap-1 leading-none flex-1">
            <span className="text-sm font-light hidden md:block uppercase">
              {item.class?.subject}
            </span>
            <span className="text-lg font-bold">{item.class?.name}</span>
            <span className="text-sm font-light hidden md:block">{item.classroom?.name}</span>

            {/* Mobile: subject | theme */}
            <div className="flex flex-row gap-1 justify-start items-center md:hidden mt-1">
              <span className="text-sm font-light">{item.class?.subject}</span>
              <span className="text-sm font-light">|</span>
              <span className="text-sm font-light">{item.classroom?.name}</span>
            </div>
          </div>

          {/* Info tambahan */}
          <div className="flex flex-col gap-[6px] justify-start items-start leading-none flex-1">
            <div className="flex flex-row items-center gap-2">
              <div className="w-4 h-4 relative">
                <img
                  alt="icon-age"
                  src="/kin/assest/image/icon-star.svg"
                  className="absolute inset-0 h-full w-full object-cover"
                />
              </div>
              <span className="text-sm font-normal">
                {item.class?.age_group ? findStatus(item.class?.age_group, AgeDefault) : '-'}
              </span>
            </div>
            <div className="flex flex-row items-center gap-2">
              <div className="w-4 h-4 relative">
                <img
                  alt="icon-teacher"
                  src="/kin/assest/image/icon-user.svg"
                  className="absolute inset-0 h-full w-full object-cover"
                />
              </div>
              <span className="text-sm font-normal">{item.teacher?.name}</span>
            </div>
            <div className="flex flex-row items-center gap-2">
              <div className="w-4 h-4 relative">
                <img
                  alt="icon-clock"
                  src="/kin/assest/image/icon-calender.svg"
                  className="absolute inset-0 h-full w-full object-cover"
                />
              </div>
              <span className="text-sm font-normal">Classroom {item.classroom?.name}</span>
            </div>
          </div>
        </div>

        <button
          onClick={() => goToBook(item)}
          disabled={isPassed}
          className={`${
            isPassed
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
              : 'bg-primary-main text-white hover:bg-primary-dark'
          } rounded-[100px] py-2 px-3 flex justify-center items-center transition-colors`}>
          <span className="text-xs font-semibold block">
            {isPassed ? 'TIME PASSED' : 'BOOK NOW'}
          </span>
        </button>
      </div>
    </div>
  );
};

export default CardClassSchedule;
